const desktop = {
  border: true,
  textAlign: 'center',
  width: '100',
  style: { padding: '10rem 20rem 10rem 20rem' },
  rounded: '@theme:card.rounded',
  noResultsButton: {
    border: true,
    rounded: '0',
  },
  iconProps: {
    size: 40,
    iconColor: 'black',
  },
  noResultsHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4',
    fontSize: '6',
  },
};

export default desktop;
